import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetUserProfileQuery } from '~/redux/api/authApiSlice';
import { useGetValuationStatsQuery } from '~/redux/api/valuationApiSlice';
import { ValuationTypeEnum } from '~/constants/enums/valuationEnums';
import { useFullRoutes } from '~/hooks';
import ValuationBanner from '~valuation/components/ValuationBanner';
import AuthButtons from '~valuation/pages/ValuationLanding/AuthButtons';

export default function ValuationLanding() {
  const { i18n } = useTranslation('app');
  const locale = i18n.language;
  const navigate = useNavigate();
  const { VALUATION_URL } = useFullRoutes();

  const { isSuccess: isUserSuccess, isLoading: isUserLoading } =
    useGetUserProfileQuery();

  const { data: statsData, isLoading: isStatsLoading } =
    useGetValuationStatsQuery(
      {
        type: ValuationTypeEnum.PORTFOLIO,
      },
      { skip: !isUserSuccess },
    );

  useEffect(() => {
    if (!isUserLoading && isUserSuccess && !isStatsLoading && statsData) {
      const hasValuations = Object.values(statsData?.typeCounts ?? {}).some(
        (count) => count > 0,
      );

      if (hasValuations) {
        navigate(VALUATION_URL.MY_VALUATIONS, { replace: true });
      } else {
        navigate(VALUATION_URL.ADD, { replace: true });
      }
    }
  }, [
    VALUATION_URL.ADD,
    VALUATION_URL.MY_VALUATIONS,
    isStatsLoading,
    isUserLoading,
    isUserSuccess,
    navigate,
    statsData,
  ]);

  if (isUserLoading || isStatsLoading)
    return (
      <div className="h-screen w-full flex justify-center items-center">
        <span className="loading loading-spinner loading-lg bg-blue"></span>
      </div>
    );

  return (
    <ValuationBanner
      ctas={<AuthButtons />}
      image={
        <>
          <div className="items-center justify-center flex md:hidden">
            <div
              className={`inline-block bg-cover mobile-${locale}-report-image w-[517px] h-[292px] `}
            ></div>
          </div>
          <div className="items-center justify-center hidden md:flex">
            <div
              className={`inline-block bg-cover desktop-${locale}-report-image w-[517px] h-[292px] `}
            ></div>
          </div>
        </>
      }
    />
  );
}
